export { default as ProductsElasticSearchCustomTagsFilterBadges } from './ProductsElasticSearchCustomTagsFilterBadges';
